import { useLanguage } from '../../../contexts/LanguageContext';

// Landing tab: the first thing shown on entering NoticeIA. Kept intentionally
// simple — a single welcome message centered in the content column.
export function NoticeHome() {
  const { t } = useLanguage();
  // ON A PHONE, THE NAME ON A LINE OF ITS OWN: "Bienvenue sur" / "NoticeIA !" (Louis 2026-10-23),
  // where one line ran edge to edge. Broken before the name, in either language.
  const welcome = t('notice.home.welcome');
  const at = welcome.lastIndexOf('NoticeIA');
  return (
    <div className="flex min-h-[60vh] flex-1 flex-col items-center justify-center px-6 text-center">
      <h1 className="font-sora text-3xl font-bold text-white">
        {at > 0 ? (
          <>
            {welcome.slice(0, at)}
            <br className="sm:hidden" />
            {welcome.slice(at)}
          </>
        ) : welcome}
      </h1>
    </div>
  );
}
